<template>
  <vue-transmit
    drag-class="dragging"
    tag="div"
    v-bind="options"
    upload-area-classes="bg-faded"
    ref="uploader"
    @success="onUploadSuccess"
    @success-multiple="onUploadSuccessMulti"
    @error="onUploadError"
    @error-multiple="onUploadErrorMulti"
  >
    <div
      class="v-btn v-btn--block v-btn--outline v-btn--depressed theme--light accent--text"
      style="height: 15rem;"
    >
      <v-layout row wrap>
        <v-flex xs12 text-xs-center>
          <v-icon class="accent--text" x-large>file_upload</v-icon>
        </v-flex>
        <v-flex xs12 text-xs-center>
          <h1>{{$t('library.uploadPlaceholder')}}</h1>
        </v-flex>
      </v-layout>
    </div>
    <template slot="files" slot-scope="props">
      <v-layout row wrap>
        <v-flex
          v-for="file in props.files"
          :key="file.id"
          xs6
          md4
          lg2
        >
          <v-card>
            <v-img :src="file.dataUrl"></v-img>
            <v-card-title primary-title>
              <div>
                <h3 class="headline">
                  <p style="word-break: break-all;">{{ file.name }}</p>
                </h3>
                <span>Type: {{ file.type }}</span>
                <p>Size: {{ file.size }}</p>
              </div>
            </v-card-title>
            <v-progress-linear
              v-model="file.upload.progress"
              color="accent"
            ></v-progress-linear>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
  </vue-transmit>
</template>

<script>
import 'animate.css/animate.css';
import { VueTransmit } from 'vue-transmit';

export default {
  components: {
    'vue-transmit': VueTransmit,
  },
  data() {
    return {
      options: {
        acceptedFileTypes: [
          'application/vnd.android.package-archive',
          'application/zip',
        ],
        maxFileSize: 2000,
        clickable: true,
        uploadMultiple: false,
        maxConcurrentUploads: 1,
        adapterOptions: {
          url: `${window.api_url}api/update`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access-token')}`,
          },
        },
      },
    };
  },
  methods: {
    triggerBrowse() {
      this.$refs.uploader.triggerBrowseFiles();
    },
    /* eslint-disable no-unused-vars */
    onUploadSuccess(file, res) {
      this.$refs.uploader.removeFile(file);
      this.$events.fire('refresh-update-table');
    },
    onUploadSuccessMulti(files, res) {
      this.$refs.uploader.removeAllFiles(false);
      this.$events.fire('refresh-update-table');
    },
    onUploadError(file, msg, data) {
      this.$refs.uploader.removeFile(file);
      this.$toasted.show(msg, { duration: 3000, singleton: true, type: 'error' });
    },
    onUploadErrorMulti(files, msg, data) {
      this.$refs.uploader.removeAllFiles(false);
      this.$toasted.show(msg, { duration: 3000, singleton: true, type: 'error' });
    },
    /* eslint-enable */
  },
};
</script>

<style>
.v-transmit__upload-area:hover {
  cursor: pointer;
}

.v-transmit__upload-area--is-dragging {
  background: #fce4ec linear-gradient(
    -45deg,#fafafa 25%,
    transparent 0,
    transparent 50%,
    #fafafa 0,
    #fafafa 75%,
    transparent 0,
    transparent
  );
  background-size: 40px 40px;
}
</style>
